import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDlxbm1GxgJSkxHuql2iAsJ3MqI__Ny9zM",
  authDomain: "monitoring-kelas-e5a8d.firebaseapp.com",
  databaseURL: "https://monitoring-kelas-e5a8d-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "monitoring-kelas-e5a8d",
  storageBucket: "monitoring-kelas-e5a8d.firebasestorage.app",
  messagingSenderId: "884636097471",
  appId: "1:884636097471:web:60e493e303208fc73a5f0a",
  measurementId: "G-6QG8D4ET9W"
};

console.log('Firebase loaded');

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export auth and db
export const auth = getAuth(app);
export const db = getDatabase(app);
export const firestore = getFirestore(app);